import { apiClient } from '../utils/api-client';

export interface Country {
  code: string;
  name: string;
}

export interface CountryState {
  code: string;
  name: string;
}

/**
 * The ISO country and subdivision lists behind the location forms' pickers.
 * Fetched rather than bundled — the full subdivision table is far larger than
 * any form needs, and a country's states are only wanted once it is chosen.
 */
class CountriesService {
  async getCountries(): Promise<Country[]> {
    const response = await apiClient.get('/api/countries');
    if (!response.ok) throw new Error('Failed to fetch countries');

    const data: { data: Country[] } = await response.json();
    return data.data;
  }

  /** The subdivisions of one country; empty for the many that have none. */
  async getStates(countryCode: string): Promise<CountryState[]> {
    const response = await apiClient.get(`/api/countries/${encodeURIComponent(countryCode)}/states`);
    if (!response.ok) throw new Error('Failed to fetch states');

    const data: { data: CountryState[] } = await response.json();
    return data.data;
  }
}

export const countriesService = new CountriesService();
